(() => {
  if (window.maComposer) return;
  window.maComposer = true;
  const normalize = text => String(text).toLowerCase().replace(/\s|\u00a0/g, '').replace(',', '.');
  function variant(flavor, size) {
    const labels = size === '1000' ? ['1kg','1000g'] : [size+'g'];
    const candidates = flavor.variants.filter(v => (v.options || [v.title]).some(o => labels.includes(normalize(o))));
    if (candidates.length === 1) return candidates[0];
    // Use an explicit net-weight metafield; shipping weight includes packaging.
    const byWeight = flavor.variants.filter(v => Number(v.netGrams) === Number(size));
    return byWeight.length === 1 ? byWeight[0] : null;
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-composer]').forEach(root => {
      if (root.dataset.initialized) return;
      const node = document.getElementById(root.dataset.config);
      if (!node) return;
      root.dataset.initialized = 'true';
      const config = JSON.parse(node.textContent), flavors = config.flavors.filter(Boolean);
      const money = c => (c/100).toLocaleString(document.documentElement.lang || 'fr-FR', {style:'currency',currency:config.currency || 'EUR'});
      const sizes = ['500','1000'].filter(s => flavors.some(f => variant(f,s)?.available));
      const canMix = config.mixedEnabled && sizes.length > 0;
      const canGift = Boolean(config.gift && config.gift.available && flavors.some(f => variant(f,'250')?.available));
      const status = root.querySelector('[data-compose-status]');
      if (!canMix && !canGift) {
        root.querySelector('.compose-tabs').hidden = true;
        root.querySelector('.compose-layout').hidden = true;
        const message = document.createElement('p');
        message.textContent = 'Les compositions sont momentanément indisponibles. Retrouvez les formats disponibles dans les fiches produits ci-dessus.';
        root.append(message); return;
      }
      let mode = canGift ? 'gift' : 'mixed', size = sizes[0] || '500', count = 3, chosen = [], busy = false;
      const format = () => mode === 'gift' ? '250' : size;
      const quantity = () => mode === 'gift' ? 3 : count;
      const available = f => Boolean(variant(f,format())?.available);
      const selected = () => chosen.map(id => flavors.find(f => String(f.id) === id)).filter(Boolean);
      const total = (items, n = quantity()) => {
        const before = items.reduce((sum,f) => sum + variant(f,format()).price, 0);
        const rate = mode === 'mixed' ? n === 5 ? Number(config.rateFive || 0) : Number(config.rateThree || 0) : 0;
        const after = mode === 'gift' ? config.gift.total : items.reduce((sum,f) => sum + Math.round(variant(f,format()).price*(100-rate)/100),0);
        return {before,after,rate,saving:Math.max(0,before-after)};
      };
      function summary() {
        const items = selected(), valid = items.length === quantity() && items.every(available);
        root.querySelector('[data-compose-title]').textContent = mode === 'gift' ? 'Mon coffret cadeau' : `${count} pots à panacher`;
        const list = root.querySelector('[data-compose-list]'); list.replaceChildren();
        const grouped = new Map();
        items.forEach(f => grouped.set(f.name,(grouped.get(f.name)||0)+1));
        for (const [name,n] of grouped) { const li = document.createElement('li'); li.textContent = `${n} × ${name} · ${format()==='1000'?'1 kg':format()+' g'}`; list.append(li); }
        const price = valid ? total(items) : {before:0,after:0,saving:0};
        root.querySelector('[data-compose-before]').textContent = mode === 'mixed' && price.saving ? money(price.before) : '';
        root.querySelector('[data-compose-total]').textContent = valid ? money(price.after) : '—';
        root.querySelector('[data-compose-saving]').textContent = mode === 'mixed' && price.saving ? `Vous économisez ${money(price.saving)}` : mode === 'gift' ? 'Coffret cadeau inclus' : '';
        root.querySelector('[data-compose-packaging]').textContent = mode === 'gift' ? '3 pots de 250 g dans leur coffret.' : 'Même format, variétés au choix. Pots sans coffret cadeau.';
        const add = root.querySelector('[data-compose-add]'); add.disabled = !valid || busy;
        add.textContent = busy ? 'Ajout en cours…' : !valid ? 'Sélection à compléter' : `Ajouter ${mode==='gift'?'mon coffret':'mes pots'} — ${money(price.after)}`;
        return {items, valid};
      }
      function render() {
        root.querySelectorAll('[data-compose-mode]').forEach(b => { b.hidden = b.dataset.composeMode==='gift' ? !canGift : !canMix; b.disabled = busy; b.setAttribute('aria-pressed',String(b.dataset.composeMode===mode)); });
        root.querySelector('[data-compose-format-wrap]').hidden = mode === 'gift';
        root.querySelector('[data-compose-offers]').hidden = mode === 'gift';
        const formatSelect = root.querySelector('[data-compose-format]'); formatSelect.value = size; formatSelect.disabled = busy;
        for (const option of formatSelect.options) option.disabled = !sizes.includes(option.value);
        const rows = root.querySelector('[data-compose-rows]'); rows.replaceChildren();
        if (mode === 'mixed') for (const n of [3,5]) {
          const rate = n === 5 ? Number(config.rateFive || 0) : Number(config.rateThree || 0);
          const row = document.createElement('label'); row.className='offer-option';
          row.innerHTML = `<input type="radio" name="compose-quantity-${root.id}" value="${n}"><span class="offer-main"><strong>${n} × POTS (${size==='1000'?'1 KG':'500 G'})</strong><small>Variétés au choix</small></span><span class="offer-amount"><strong>${rate?'−'+rate+' %':''}</strong></span>`;
          const input = row.querySelector('input'); input.checked = count===n; input.disabled=busy;
          input.onchange = () => { count=n; render(); }; rows.append(row);
        }
        const eligible = flavors.filter(available);
        chosen = Array.from({length:quantity()},(_,i) => eligible.some(f => String(f.id)===chosen[i]) ? chosen[i] : String(eligible[i%eligible.length]?.id || ''));
        const slots = root.querySelector('[data-compose-slots]'); slots.replaceChildren();
        chosen.forEach((id,i) => {
          const slot = document.createElement('div'); slot.className='compose-slot';
          const img=document.createElement('img'); img.alt=''; img.width=60; img.height=78;
          const body=document.createElement('div'),label=document.createElement('label'),select=document.createElement('select');
          select.id=`${root.dataset.config}-pot-${i}`; label.htmlFor=select.id;
          label.textContent=`Pot ${i+1} · ${format()==='1000'?'1 kg':format()+' g'}`;
          flavors.forEach(f => { const option=document.createElement('option'); option.value=String(f.id); option.textContent=f.name+(available(f)?'':' — indisponible'); option.disabled=!available(f); select.append(option); });
          select.value=id; select.disabled=busy;
          const updateImage=()=>{ const f=flavors.find(f=>String(f.id)===select.value); img.hidden=!f?.image; if(f?.image)img.src=f.image; }; updateImage();
          select.onchange=()=>{chosen[i]=select.value; updateImage(); status.textContent=''; summary();};
          body.append(label,select); slot.append(img,body); slots.append(slot);
        });
        root.querySelector('[data-compose-count]').textContent=quantity()+' pots';
        root.querySelector('[data-compose-note]').textContent='Choix selon les disponibilités du format sélectionné. Les répétitions sont possibles dans la limite du stock.';
        summary();
      }
      root.querySelectorAll('[data-compose-mode]').forEach(b => b.onclick=()=>{if(busy)return;mode=b.dataset.composeMode;render();});
      root.querySelector('[data-compose-format]').onchange=e=>{if(busy)return;size=e.target.value;render();};
      document.querySelectorAll('[data-open-gift]').forEach(link=>link.addEventListener('click',()=>{if(canGift&&!busy){mode='gift';render();}}));
      root.querySelector('[data-compose-add]').onclick=async()=>{
        if(busy)return; const selection=summary(); if(!selection.valid)return;
        let items;
        if(mode==='gift') {
          const properties={};
          selection.items.forEach((f,i)=>properties['Pot '+(i+1)]=f.name+' · 250 g');
          properties._mesabeilles_components=selection.items.map(f=>variant(f,'250').id).join(',');
          items=[{id:config.gift.variantId,quantity:1,properties}];
        } else {
          const quantities=new Map();
          selection.items.forEach(f=>{const id=variant(f,size).id;quantities.set(id,(quantities.get(id)||0)+1);});
          items=[...quantities].map(([id,quantity])=>({id,quantity}));
        }
        busy=true;status.textContent='';render();
        try {
          const response=await fetch((window.Shopify?.routes?.root||'/').replace(/\/?$/, '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const data=await response.json();
          if(!response.ok)throw new Error(data.description||data.message||'Cette sélection ne peut pas être ajoutée. Vérifiez les disponibilités.');
          window.location.assign(config.cartUrl||'/cart');
        } catch(error) {
          status.textContent=error.message==='Failed to fetch'?'Connexion interrompue. Consultez votre panier avant de réessayer.':error.message;
          busy=false;render();
        }
      };
      render();
    });
  }
  init(); document.addEventListener('shopify:section:load',event=>init(event.target));
})();
